
import gql from 'graphql-tag'

// """查询会员列表"""
export const findMembers = gql`
  query($order: [MembersFindOrder!], $paging: PagingQuery, $where: MembersFindFilter) {
    findMembers(
      order: $order,
      paging: $paging,
      where: $where,
    ) {
      members {
        id
        nickname
        profilePhoto
        uniqueId
        createdAt
        updatedAt
      }
      paging {
        currentOffset
        take
        totalCount
      }
    }
  }
`

// """删除会员"""
export const deleteMember = gql`
  mutation($memberId: Int!) {
    deleteMember(memberId: $memberId)
  }
`

export const exportMembersList = gql`
  query($order: [MembersFindOrder!],$where: MembersFindFilter) {
    exportMembersList(
      order: $order,
      where: $where
    ) {
      fileName
      contentB64
    }
  }
`
